import Queue from '@segment/localstorage-retry'

/**
 * Queue options
 *
 * Attempt with exponential backoff for upto 10 times.
 * Backoff periods are: 1s, 2s, 4s, 8s, 16s, 32s, 64s, 128s (~2m), 256s (~4m),
 * 512s (~8.5m) and 1024s (~17m).
 */
export const queueOptions = {
  maxRetryDelay: 360000, // max interval of 1hr. Added as a guard.
  minRetryDelay: 1000, // first attempt (1s)
  backoffFactor: 2,
  maxAttempts: 10,
  maxItems: 100,
}

let queue
export const getQueue = () => {
  if (!queue) {
    queue = initializeQueue()
  }

  return queue
}

export const initializeQueue = () => {
  const newQueue = new Queue('perspective', queueOptions, queueExecute)

  newQueue.start()

  return newQueue
}

/**
 *
 * @param {Object} item
 * @param {String} item.url
 * @param {message} item.message
 * @param {Function} done
 */
export const queueExecute = (item, done) => {
  // apply sentAt at flush time and reset on each retry
  // so the tracking-api doesn't interpret a time skew
  item.message.sentAt = new Date().toISOString()

  send(item.message, item.url, function (err, res) {
    if (err) {
      return done(err)
    }
    done(null, res)
  })
}

/**
 *
 * @param {Object} body
 * @param {String} url
 * @param {Function} onFail
 * @param {Number} [timeout=10000]
 */
export const send = (body, url, onFail, timeout = 10000) => {
  const req = new XMLHttpRequest()
  req.onerror = onFail
  req.onreadystatechange = done

  req.open('POST', url, true)

  req.timeout = timeout
  req.ontimeout = onFail

  req.setRequestHeader('Content-Type', 'text/plain')
  req.send(JSON.stringify(body))

  function done() {
    if (req.readyState === 4) {
      // Fail on 429 and 5xx HTTP errors
      if (req.status === 429 || (req.status >= 500 && req.status < 600)) {
        onFail(new Error('HTTP Error ' + req.status + ' (' + req.statusText + ')'))
      } else {
        onFail(null, req)
      }
    }
  }
}

/**
 * @typedef {Object} message
 * @property {context} context
 * @property {String} messageId
 * @property {String} sentAt
 * @property {String} type
 * @property {String} properties
 * @property {String} timestamp
 */

/**
 * @typedef {Object} context
 * @property {String} userAgent
 * @property {contextPage} page
 * @property {String} locale
 */

/**
 * @typedef {Object} contextPage
 * @property {String} path
 * @property {String} referrer
 * @property {String} search
 * @property {String} title
 * @property {String} url
 */
